/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//--------------
// Plugins
//--------------
require('./bootstrap');
var Modernizr = require('./plugins/modernizr');
require('./plugins/jquery.validate.min');
require('./plugins/select2.min');
require('./plugins/datepicker');

//--------------
// Variables
//--------------
window.App = {};
var App = window.App;

App.Swiper = require('./plugins/swiper.min');
App.windowWidth = $(window).outerWidth();
App.windowHeight = $(window).outerHeight();

//--------------
// VueJS
//--------------

require('./methods');
require('./import');

//--------------
// Methods
//--------------

/**
 * Init all scripts
 * @return {void}
 */
App.init = function(){
	//-- Tips for valid form
	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});

	//-- Form validate
	$('.js-form-validate').each(function(){
		$(this).validate({
			errorPlacement: function(error, element) {
			    error.insertBefore(element);
			}
		});
	});

	// Format card number
	$('body').on('keydown', '#card-number', function(e){
		var value = App.addGaps($(this).val(), e);
		$(this).val(value);
	});

	// Format card date
	$('body').on('keydown', '#card_expiry-date', function(e){
		var value = App.addSlash($(this).val(), e);
		$(this).val(value);
	});


	// HTML Listener
	MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations, observer) {
	    if($('.popup-content').length > 0){
	    	$('html').addClass('overflow-hidden');
	    	$('body').addClass('overflow-hidden');
	    } else {
				$('html').removeClass('overflow-hidden');
				$('body').removeClass('overflow-hidden');
	    }
	});

	// define what element should be observed by the observer
	// and what types of mutations trigger the callback
    if (document.querySelector('.js-scroll-container')) {
        observer.observe(document.querySelector('.js-scroll-container'), {
            subtree: true,
            attributes: true,
            childList: true
        });
    }

	//----------------------
	// Cookies
	//----------------------
	require('./modules/cookies.js');

	//----------------------
	// Popup
	//----------------------
	let popup = document.querySelectorAll('[data-module="popup"]');
	if (popup.length > 0) {
	  require('./modules/popup.js');
	}

	//----------------------
	// Map
	//----------------------
	let map = document.querySelectorAll('[data-module="map"]');
	if (map.length > 0) {
	  require('./modules/map.js');
	}

    //----------------------
    // Product gallery
    //----------------------
    let productGallery = document.querySelectorAll('[data-module="product-gallery"]');
    if (productGallery.length > 0) {
        require('./modules/product-gallery.js');
    }

	//----------------------
	// Menu
	//----------------------
	let navbar = document.querySelectorAll('[data-module="navbar"]');
	if (navbar.length > 0) {
	  require('./modules/navbar.js');
	}

	//----------------------
	// Collapse
	//----------------------
	require('./modules/collapse.js');

	//----------------------
	// Scroll top
	//----------------------
	require('./modules/scroll-top.js');

	//----------------------
	// Home Carousel
	//----------------------
	var $coverflowCarousel = $('[data-module="testimonials"]');
	if ($coverflowCarousel.length > 0) {
	  var CoverflowCarousel = require('./modules/testimonials.js');
	}

	//----------------------
	// Products Carousel
	//----------------------
	var $productsCarousel = $('[data-module="products-carousel"]');
	if ($productsCarousel.length > 0) {
	  var ProductsCarousel = require('./modules/products-carousel.js');
	}

	//----------------------
	// Register
	//----------------------
	var $register = $('[data-module="register"]');
	if ($register.length > 0) {
	  var Register = require('./modules/register.js');
	}

}


//--------------
// Functions
//--------------

App.addGaps = function(str, e) {
  if (str && str.length > 0) {
    str = str.replace(/\s/g, "");
    str = str.match(/.{1,4}/g);
    str = str.join(" ");
  }

  return str;
}

App.addSlash = function(str, e) {
  if (str && str.length > 0) {
    //str = str.replace("/", "");
    //str = str.match(/.{1,2}/g);
    //str = str.join("/");

   if(str.length == 2 && e.keyCode != 8){
    	str = str + '/';
    }
  }

  return str;
}


//--------------
// Execution
//--------------

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});
